import { map } from 'rxjs/operators/map';
import { ActionSerializer } from '../../models';
import ajax from '../../utils/ajax';

class ActionService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/action';
  configurationPathGroup = '/networkAsset/airfinder/actions';

  /**
    Get Action in a trigger
    @param {String} triggerId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  getByTriggerId = (triggerId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?triggerId=${triggerId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(ActionSerializer.normalize)));
  };

  /**
    Create an Action
    @param {Object} action
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (action, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: ActionSerializer.serialize(action),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => ActionSerializer.normalize(data.response)));
  };

  /**
    Edit an Action
    @param {Object} action
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  edit = (action, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${action.id}`,
        body: ActionSerializer.serialize(action),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => ActionSerializer.normalize(data.response)));
  };

  /**
    Delete an Action
    @param {Object} action
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  delete = (action, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${action.id}`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };
}

export default new ActionService();



// WEBPACK FOOTER //
// ./src/services/action/index.js